import { Link } from "react-router-dom";

const NotFound = () => {
	return (
		<div className="min-h-screen bg-secondary flex items-center justify-center p-4">
			<div className="text-center">
				<h1 className="text-6xl font-light text-gray-800 mb-4">404</h1>
				<p className="text-xl text-gray-600 mb-8">
					Oops! That page doesn't exist.
				</p>
				<Link
					to="/"
					className="inline-block px-8 py-3 bg-[#FF5C00] text-white font-semibold rounded-lg hover:bg-[#e54f00] transition-colors duration-200"
				>
					Back to Home
				</Link>
			</div>
		</div>
	);
};

export default NotFound;
